import React, { useContext } from 'react'
import * as Yup from 'yup'
import { FormContainer, Input, Select, Checkbox, Datepicker, Radio } from 'components/Form'
import { IntlContext } from 'features/multilingual'
import { useIntl } from 'hooks'

const Index = () => {
    const context = useContext(IntlContext)
    const { t } = useIntl()

    return (
        <div>
            <FormContainer
                initialValues={{
                    name: '',
                    age: '',
                    email: '',
                    select: ['en'],
                    terms: false,
                    ch: [],
                    sign: false,
                    // date: '',
                    size: '',
                }}
                onSubmit={values => {
                    alert(JSON.stringify(values, null, 2))
                }}
                validationSchema={{
                    name: Yup.string().typeError('Invalid name').required('Required'),
                    age: Yup.number()
                        .positive('Invalid age')
                        .max(100, 'Invalid age')
                        .required('Required'),
                    email: Yup.string().email('Invalid email').required('Required'),
                    select: Yup.array().min(1),
                    size: Yup.string().required('Required'),
                }}
            >
                {formik => {
                    return (
                        <React.Fragment>
                            <Input name="name" type="text" placeholder="Enter name..." />
                            <Input name="age" type="text" placeholder="Enter age..." />
                            <Select
                                name="select"
                                placeholder="Select an option"
                                label="Language"
                                onChange={e => {
                                    const val = e.target.value[0] //.split('-')
                                    // if (val.length === 2) {
                                    //     val = [`${val[0]}-${val[1].toUpperCase()}`]
                                    // }
                                    // context.setLanguage(val[0])
                                    context.setLanguage(val)
                                    formik.setFieldValue('select', e.target.value)
                                }}
                                options={['en', 'de', 'pt']}
                            />
                            {/* <Checkbox name="sign" label="Sign me up for the newsletter" /> */}
                            {/* <Checkbox name="terms">
                                <span>
                                    I agree to the{' '}
                                    <a href="/Product/TermsOfUse" target="_blank">
                                        terms of use
                                    </a>
                                </span>
                            </Checkbox> */}
                            <Checkbox name="ch" label="1" value="one" />
                            <Checkbox name="ch" label="2" value="two" />
                            <Datepicker locale="en-US" name="date" />
                            <Radio name="size" options={['small', 'medium', 'large']} />
                            <button type="submit" onClick={formik.handleSubmit}>
                                submit
                            </button>
                        </React.Fragment>
                    )
                }}
            </FormContainer>
        </div>
    )
}

export default Index
